import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
export default function PasswordInput({ label, Placeholder, value, errors, touched, name, onChange, onBlur, type }) {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };
    const handleMouseDownPassword = (e) => {
        e.preventDefault();
    };
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { name: name, value: value, fullWidth: true, type: showPassword ? "text" : "password", label: label, placeholder: Placeholder, autoComplete: "current-password", className: "form-input-root", onChange: onChange, onBlur: onBlur, InputLabelProps: { shrink: true }, InputProps: {
                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end", className: "password-toggle-button", children: showPassword ? (_jsx(VisibilityOffIcon, { fontSize: "small" })) : (_jsx(VisibilityIcon, { fontSize: "small" })) }) })),
                } }), errors && touched ? _jsx("div", { className: 'error-label', children: _jsx("p", { children: errors && touched ? errors : null }) }) : null] }));
}
